var _circle, _path, _path2, _path3, _path4, _path5, _path6;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconMail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 9,
    fill: "#DCEFE1"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7588 6.99219L9.56805 9.28659L9.07005 9.64539L8.55285 9.28659L5.24805 6.99219H12.7588Z",
    fill: "#004C3B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.29849 9.40503L5.03809 10.875V7.14062L8.29849 9.40503Z",
    fill: "#004C3B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6803 11.0076H5.3291L8.5271 9.56641L9.0719 9.94441L9.5939 9.56881L12.6803 11.0076Z",
    fill: "#004C3B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.7588 6.99219L9.56805 9.28659L9.07005 9.64539L8.55285 9.28659L5.24805 6.99219H12.7588Z",
    fill: "#004C3B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9626 7.14453V10.8729L9.81738 9.40653L12.9626 7.14453Z",
    fill: "#091E0E"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M13.4424 11.486H4.55762V6.51562H13.4424V11.486ZM4.79762 11.246H13.2024V6.75563H4.79762V11.246Z",
    fill: "#091E0E"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/IconMail.c3ef67cdf4f491aff166a2fcb8cc0995.svg";
export { ForwardRef as ReactComponent };